/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { Flex } from '@chakra-ui/react'
import { useEffect } from 'react'

export interface ISeriesDataStackedColumn {
  name: string
  data: number[]
}

export interface IStackedColumnChartData {
  dates: string[]
  questao: string
  qtdRespostasTotal: number
  series: ISeriesDataStackedColumn[]
  seriesEscala: number[]
}

interface StackedColumnChartProps {
  id: string
  data: IStackedColumnChartData
  colorsGrafico?: string[]
  height?: string | number
  width?: string | number
}

export const StackedColumnChart: React.FC<StackedColumnChartProps> = ({
  id,
  data,
  colorsGrafico,
  height = 380,
  width = '100%'
}) => {
  const chartInstanceId = `apexchart-instance-${id}`

  useEffect(() => {
    const chartElement = document.querySelector(`#chart-${id}`)

    if (!chartElement) {
      return
    }

    if (!data?.dates || !data.series) {
      chartElement.innerHTML = ''
      return
    }

    const options: ApexCharts.ApexOptions = {
      series: data.series,
      chart: {
        id: chartInstanceId,
        type: 'bar',
        height: height,
        stacked: true,
        stackType: '100%',
        toolbar: {
          show: true
        }
      },
      colors: colorsGrafico,
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '70%'
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '10px',
          colors: ['#333']
        }
      },
      xaxis: {
        categories: data.dates
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
        offsetY: -5
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (val: number) => {
            return `${val}`
          }
        }
      }
    }

    const existingChart = ApexCharts.getChartByID(chartInstanceId)
    if (existingChart) {
      existingChart.destroy()
    }

    const chart = new ApexCharts(chartElement, options)
    chart.render()
    return () => {
      const chartToDestroy = ApexCharts.getChartByID(chartInstanceId)
      if (chartToDestroy) {
        chartToDestroy.destroy()
      }
    }
  }, [id, data, colorsGrafico, height, width, chartInstanceId])

  return <Flex id={`chart-${id}`} w={width} minH={height} />
}
